import { render, staticRenderFns } from "./AccountRolesTable.vue?vue&type=template&id=6c41db6f&scoped=true&"
import script from "./AccountRolesTable.vue?vue&type=script&lang=js&"
export * from "./AccountRolesTable.vue?vue&type=script&lang=js&"
import style0 from "./AccountRolesTable.vue?vue&type=style&index=0&id=6c41db6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c41db6f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
